import { Typography, Card, Divider } from "antd";

const { Title, Paragraph, Text, Link } = Typography;

export default function Security() {
  return (
    <div className="admin-static-page">
      <Card bordered>
        <Typography>
          <Title level={2}>
            Estándares de seguridad infantil – Swingers VIP
          </Title>

          <Paragraph>
            En <Text strong>Swingers VIP</Text> condenamos enérgicamente
            toda forma de explotación y abuso sexual infantil (CSAE). Está
            estrictamente prohibida la publicación, distribución o promoción de
            material de abuso sexual infantil en nuestra plataforma.
          </Paragraph>

          <Divider />

          <Title level={3}>1. Prevención y detección</Title>
          <Paragraph>
            Contamos con sistemas de moderación y revisión de contenido para
            prevenir y detectar comportamientos inapropiados. Todos los reportes
            de usuarios son analizados con prioridad.
          </Paragraph>

          <Title level={3}>2. Reportes y denuncias</Title>
          <Paragraph>
            Los usuarios pueden reportar perfiles, mensajes o imágenes
            sospechosas directamente desde la app. También pueden escribirnos a
            nuestro correo oficial de seguridad:
          </Paragraph>
          <Card
            style={{
              backgroundColor: "#f0f5ff",
              borderLeft: "4px solid #1677ff",
              marginBottom: "16px",
            }}
          >
            📧 <Text strong>Email:</Text>{" "}
            <Link href="mailto:infoswingersvip@gmail.com">
              infoswingersvip@gmail.com
            </Link>
          </Card>
          <Paragraph>
            Todo reporte será revisado y, en caso de ser necesario, se informará
            a las autoridades competentes.
          </Paragraph>

          <Title level={3}>3. Colaboración con autoridades</Title>
          <Paragraph>
            Cooperamos activamente con organismos oficiales y organizaciones
            internacionales dedicadas a erradicar el CSAE, cumpliendo con las
            leyes locales e internacionales aplicables.
          </Paragraph>

          <Title level={3}>4. Contacto</Title>
          <Paragraph>
            Para consultas relacionadas con la seguridad infantil, puedes
            escribirnos a: <br />
            📧{" "}
            <Link href="mailto:infoswingersvip@gmail.com">
              infoswingersvip@gmail.com
            </Link>
          </Paragraph>

          <Paragraph type="secondary" italic>
            Última actualización: septiembre 2025
          </Paragraph>
        </Typography>
      </Card>
    </div>
  );
}
